/* Edit case */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FaTimes } from "react-icons/fa";
import "../components/CaseSelector/CaseEntries/CaseEntries.css";
import Modal from "react-responsive-modal";
import {
	requestPageOfDandOs,
	getDandOInfoById
} from "../components/Admin/storeDandO/action";
import axios from "axios";
import { apiUri } from "../config";
import { NotificationManager } from "react-notifications";
import DatePicker from "react-datepicker";
import {
	//padCalendar,
	//numberWithCommas,
	allowAlphaNumeric,
	onlyNumeric,
	//formatDateAdded,
	isAdmin/*,
	isDandoEnabled*/
} from "../util";
import DisclosureModal from "./components/DisclosureModal";

import Select from 'react-select';
import TableGrid from "../common/components/TableGrid/tableGrid";
import { dandOEntriesColumns } from "../common/components/TableGrid/tableColumn/DandOEntriesColumns";

const state = {
	className: "CaseSelectorEntry"
};

const integerRegrex = /^[0-9]*$/;
const aphabetnumberRegex = /^[a-zA-Z0-9]*$/;

class DandOEntries extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: "",
			dandoDataArray: [],
			currentDandOs: [],
			sortValue: "",
			sortOrder: "",
			DandOData: {},
			className: "CaseSelectorEntry",
			isAdminToken: isAdmin(),
			open: false,
			fileUploadOpen: false,
			heading: "Update Risk",
			EditDandOData: {},
			EditDandOFile: {},
			openDelete: false,
			viewerModal: false,
			deleteModalData: {},
			companyNameError: "",
			riskAssessmentDateError: "",
			tickerError: "",
			sicCodeError: "",
			cikError: "",
			marketError: "",
			caseFileError: "",
			notesError:"",
			indexListIdError:"",
			identifierError: "",
			fileUploadError: "",
			enableView: false,
			enableCMView: false,
			enableDandO: false,
			indexList: [],
			DandOInfo: false,
			fileUploadDandOId: false
		};
		this.handleEdit = this.handleEdit.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleSaveDandO = this.handleSaveDandO.bind(this);
		this.handleFileUpload = this.handleFileUpload.bind(this);
		this.handleRiskImport = this.handleRiskImport.bind(this);
		this.handleCompanyRisk = this.handleCompanyRisk.bind(this);
		this.goToCases = this.goToCases.bind(this);
	}

	goToCases(id) {
		sessionStorage.setItem('DANDO',true);
		this.props.history.push("/cases/" + id);
	}
	handleSaveDandO(data) {
		let status = true;
		if (
			!this.state.EditDandOData.companyName ||
			this.state.EditDandOData.companyName.trim() === ""
		) {
			status = false;
			this.setState({
				companyNameError: "Company Name required!"
			});
		} else {
			this.setState({ companyNameError: "" });
		}

		if (
			!this.state.EditDandOData.riskAssessmentDate ||
			this.state.EditDandOData.riskAssessmentDate === ""
		) {
			status = false;
			this.setState({
				riskAssessmentDateError: "Risk Assessment Date required!"
			});
		} else {
			this.setState({ riskAssessmentDateError: "" });
		}

		if (
			!this.state.EditDandOData.ticker ||
			this.state.EditDandOData.ticker.trim() === ""
		) {
			status = false;
			this.setState({
				tickerError: "Ticker required!"
			});
		} else {
			if (!aphabetnumberRegex.test(this.state.EditDandOData.ticker)) {
				status = false;
				this.setState({
					tickerError: "Enter only alphanumeric characters"
				});
			} else {
			this.setState({ tickerError: "" });
			}
		}

		if (
			!this.state.EditDandOData.identifier ||
			this.state.EditDandOData.identifier.trim() === ""
		) {
			status = false;
			this.setState({
				identifierError: "Identifier required!"
			});
		} else {
			if (!aphabetnumberRegex.test(this.state.EditDandOData.identifier)) {
				status = false;
				this.setState({
					identifierError: "Enter only alphanumeric characters"
				});
			} else {
				this.setState({ identifierError: "" });
			}
		}

		if (
			!this.state.EditDandOData.sicCode ||
			this.state.EditDandOData.sicCode === ""
		) {
			status = false;
			this.setState({
				sicCodeError: "SIC Code required!"
			});
		} else {
			if (!integerRegrex.test(this.state.EditDandOData.sicCode)) {
				status = false;
				this.setState({
					sicCodeError: "Enter only numbers"
				});
			} else {
			this.setState({ sicCodeError: "" });
			}
		}
		if (
			!this.state.EditDandOData.cik ||
			this.state.EditDandOData.cik === ""
		) {
			status = false;
			this.setState({
				cikError: "SIC Code required!"
			});
		} else {
			if (!integerRegrex.test(this.state.EditDandOData.cik)) {
				status = false;
				this.setState({
					cikError: "Enter only numbers"
				});
			} else {
			this.setState({ cikError: "" });
			}
		}

		if (
			!this.state.enableDandO &&
			(!this.state.EditDandOData.market ||
			this.state.EditDandOData.market.trim() === "")
		) {
			status = false;
			this.setState({
				marketError: "Market required!"
			});
		} else {
			this.setState({ marketError: "" });
		}

		if (
			!this.state.enableDandO &&
			(!this.state.EditDandOData.caseFile ||
			this.state.EditDandOData.caseFile.trim() === "")
		) {
			status = false;
			this.setState({
				caseFileError: "Case File required!"
			});
		} else {
			this.setState({ caseFileError: "" });
		}

		if (
			!this.state.EditDandOData.indexListId ||
			isNaN(this.state.EditDandOData.indexListId)
		) {
			status = false;
			this.setState({
				indexListIdError: "Must Select an industry index!"
			});
		} else {
			this.setState({ indexListIdError: "" });
		}
		
		if (status) {
			this.props.handleSaveFileData(data);
			this.setState({ open: false });
			if (this.state.enableDandO) {
				this.props.requestPageOfDandOs(
					this.props.currentPage,
					this.state.sortValue,
					this.state.sortOrder
				);
			} 
		} else {
			return false;
		}
	};

	componentWillReceiveProps(nextProps) {
		if (nextProps && nextProps.dandos) {
			if (this.state.isAdminToken && this.state.routeName === "/dandos") {
				this.setState({ enableView: true });
			}
			nextProps.dandos.forEach(element => {
				element.enableEdit = false;
				element.riskAssessmentDate_UI = element.riskAssessmentDate;
			});
			this.setState({ dandoDataArray: nextProps.dandos });
			if (this.state.routeName === "/DandOManagement") {
				this.setState({ enableDandO: true });
			}
			
		}
	};

	componentWillMount() {
		let state = this.state;
		state.dandoDataArray = this.props.dandos;

		state.dandoDataArray.forEach(element => {
			element.enableEdit = false;
			element.riskAssessmentDate_UI = element.riskAssessmentDate;
		});
		state.routeName = window.location.pathname;
		this.setState(state);
		this.setState({ dandoDataArray: state.dandoDataArray });
	};

	componentDidMount() {
		if (this.state.routeName === "/DandOManagement") {
			this.setState({ enableDandO: true });
			this.getIndexList();
		}
	};

	handleDelete = dando => {
		let url = "";
		
		if (this.state.enableDandO) {
			url = "/dando/" + dando.dandoId;
		} 
		axios
			.delete(apiUri + url)
			.then(json => {
			if (json.data && json.data.statusCode === 204) {
				NotificationManager.success("Risk Deleted", "Success");
				this.setState({ openDelete: false, deleteModalData: {} });
				if (this.state.enableDandO) {
					this.props.requestPageOfDandOs(
						this.props.currentPage,
						this.state.sortValue,
						this.state.sortOrder
					);
				} 
			}
			})
			.catch(err => {
			NotificationManager.error(err);
			console.log(err);
			});
	};

	handleOnChange = (DandOData, value, key) => {
		let state = this.state;
		if (key === "enabled") {
			this.setState({ [value.name]: value.value, [value.name + "Error"]: "" });
			if (value === "false") {
				state.EditDandOData["enabled"] = true;
			} else {
				state.EditDandOData["enabled"] = false;
			}
		} else if (key === "riskAssessmentDate" ) {
			this.setState({ [key]: value, [key + "Error"]: "" });
			let d = value;
			//d.setTime( d.getTime() + d.getTimezoneOffset()*60*1000 );
			state.EditDandOData[key] = new Date(value).getTime();
			state.EditDandOData[key + "_UI"] =
			new Date(d).getFullYear() +
			"-" +
			("0" + (new Date(d).getMonth() + 1)).slice(-2) +
			"-" +
			("0" + new Date(d).getDate()).slice(-2);
		} else {
			this.setState({ [value.name]: value.value, [value.name + "Error"]: "" });
			state.EditDandOData[key] = value;
		}
		this.setState({ EditDandOData: state.EditDandOData });
		if (state.enableDandO) {
			
			
		} else {
			this.props.requestPageOfDandOs(
				this.props.currentPage,
				this.state.sortValue,
				this.state.sortOrder
			);
		}
		
	};

	handleDandOStatusOnChange = (DandOData, value, key) => {
		let state = this.state;
		this.setState({ [value.name]: value.value, [value.name + "Error"]: "" });
		state.EditDandOFile[key] = value;
		this.setState({ EditDandOFile: state.EditDandOFile });
		
	};

	handleEnable = (DandOData, value, key) => {
		let state = this.state;
		state.dandoDataArray.forEach(element => {
			if (state.enableDandO) {
				if (element.dandoId === DandOData.dandoId) {
					if (value === "false") {
						element["enabled"] = true;
					} else {
						element["enabled"] = false;
					}
					this.props.handleSaveStatus(element);
				}
			} else {
				if (element.dandoId === DandOData.dandoId) {
					if (value === "false") {
						element["enabled"] = true;
					} else {
						element["enabled"] = false;
					}
					this.props.handleSaveStatus(element);
				}
			}
		});
	};

	componentDidCatch(error, errorInfo) {
		console.log("Error:", error, errorInfo);
	}

	handleEdit = (DandOData, value) => {
		let state = this.state;
		state.dandoDataArray.forEach(element => {
			if (state.enableDandO) {
				if (element.id === DandOData.id) {
					element.enableEdit = true;
					element.riskAssessmentDate =
						new Date(element.riskAssessmentDate_UI).getTime() +
						new Date(element.riskAssessmentDate_UI).getTimezoneOffset() *
						60 *
						1000;
				}
			} else {
				if (element.dandoId === DandOData.dandoId) {
					element.enableEdit = true;
					element.riskAssessmentDate =
						new Date(element.riskAssessmentDate_UI).getTime() +
						new Date(element.riskAssessmentDate_UI).getTimezoneOffset() *
						60 *
						1000;
				}
			}
		});
		this.setState(state);
		this.setState({ EditDandOData: DandOData, open: true });
		
	};

	handleFileUpload = (DandOData, value) => {
		let myExcelFileName = "";
		let myPdfFileName = "";
		if(DandOData && DandOData.excelURL) {
			let excelArr = DandOData.excelURL.split("/");
			excelArr = excelArr[excelArr.length-1].split("?");
			myExcelFileName = excelArr[0];

		}
		if(DandOData && DandOData.pdfURL) {
			let pdfArr = DandOData.pdfURL.split("/");
			pdfArr = pdfArr[pdfArr.length-1].split("?");
			myPdfFileName = pdfArr[0];

		}
		this.setState({ EditDandOFile: DandOData, fileUploadOpen: true, selectedExcelFileName: myExcelFileName, selectedPdfFileName: myPdfFileName });


	};
	handleRiskImport = (caseId) => {
		axios
			.post(apiUri +'/admin/storeAndGenerateRiskInputFile/' + caseId, {})
			.then(res => {
				if (res.status && res.status >= 200 && res.status < 300) {
					NotificationManager.success(res.data.statusMessage, "Request Accepted");
				} else {
					NotificationManager.error(res.data.statusMessage, "Failure");
				}
				
			})
			.catch(err => {
				console.log(err);
			});

	};	h
	handleCompanyRisk = (caseId) => {
		axios
			.post(apiUri +'/admin/runRisk/' + caseId, {})
			.then(res => {
				if (res.status && res.status >= 200 && res.status < 300) {
					NotificationManager.success(res.data.statusMessage, "Request Accepted");
				} else {
					NotificationManager.error(res.data.statusMessage, "Failure");
				}
				
			})
			.catch(err => {
				console.log(err);
			});

	};
	handleViewer = (viewerFileURL, viewerFileType) => {

		let myURL = "https://docs.google.com/viewer?url="+encodeURIComponent(viewerFileURL)+"&embedded=true";
		if(viewerFileType === 'xlsx')
			myURL = "https://view.officeapps.live.com/op/embed.aspx?src="+encodeURIComponent(viewerFileURL);
			

		this.setState({ viewerModal: true, viewerFileUrl: myURL});
		
	};
	onOpenModal = () => {
		this.setState({ open: true });
	};

	onCloseModal = () => {
		this.setState({ open: false, openDelete: false });
		this.resetErrorStat();
	};

	onCloseUploadModal = () => {
		this.setState({ open: false, fileUploadOpen: false });
		this.resetErrorStat();
	};

	onCloseViewerModal = () => {
		this.setState({ open: false, viewerModal: false });
		this.resetErrorStat();
	};

	onCloseDandOInfoModal = () => {
		this.setState({ DandOInfo: false });
	};

	resetErrorStat = () => {
		this.setState({
			companyNameError: "",
			riskAssessmentDateError: "",
			tickerError: "",
			docketIdError: "",
			sicCodeError: "",
			cikError: "",
			marketError: "",
			caseFileError: "",
			notesError:"",
			indexListIdError:"",
			identifierError: ""
		});
	};

	handleChange = name => event => {
		this.setState({ ...state, [name]: event.target.checked });
	};

	handleSelectChange = (selectedOption) => {
		let state = this.state;
		this.setState({ "indexListId": selectedOption.value, "indexListIdError": "" });
		state.EditDandOData["indexListId"] = selectedOption.value;
	//var getIndex = this.state.indexList.map(function (options) { return options.value; }).indexOf(selectedOption.value);

	};

	handleInfo = (selectedDando) => {

		this.setState({
			DandOInfo: true
		});
		this.setState({ "currentDandO": selectedDando});

	};

	setSelectDefault = (inValue) => {
		var getIndex = this.state.indexList.map(function (options) { return options.value; }).indexOf(inValue);
		return getIndex;
	};

	getIndexList() {
		axios
			.get(apiUri + "/cases/getIndexList")
			.then(res => {
				this.setState({
					indexList: res.data['content']
				});

			})
			.catch(err => {
				console.log(err);
			});

	};

	getamendClaimsList() {
		axios
			.get(apiUri + "/cases/amendClaims")
			.then(res => {
				this.setState({ amendClaimsList: res.data.content });
			})
			.catch(err => {
				console.log(err);
			});
	};

	getDandOInfoById(id) {
		this.setState({
			DandOInfo: true
		});
		let myResponse = this.props.getDandOInfoById(id);

		this.setState({currentDandO : myResponse})
	};

	handleOnFileChange(event) { 
		// Update the state 
		if(event.target.name === "excelFile") {
			this.setState({ selectedExcelFile: event.target.files[0] }); 
			this.setState({ selectedExcelFileName: event.target.files[0].name }); 
		} else if (event.target.name === "pdfFile") {
			this.setState({ selectedPdfFile: event.target.files[0] }); 
			this.setState({ selectedPdfFileName: event.target.files[0].name });
		}
	
	};
	 
	// On file upload (click the upload button) 
	handleOnFileUpload(dandoId) { 
	
	// Create an object of formData 
		if(this.state.selectedExcelFile) {
			axios
				.get(apiUri + "/dando/" + dandoId.dandoId + "/upload/xlsx")
				.then(res => {
					this.setState({
						uploadExcelFileName: res.data.data['fileURL']
					});

					var axiosUploader = axios.create();
					delete axiosUploader.defaults.headers.common['Authorization'];
					axiosUploader.put(this.state.uploadExcelFileName, this.state.selectedExcelFile)
					.then(res => {
						NotificationManager.success("Excel File Uploaded Successfully", "Success");
					});
				})
				.catch(err => {
					console.log(err);
					NotificationManager.error("Failed to upload file: Excel", "Error");
				});

			this.setState({ fileUploadOpen: false });
		  // Request made to the backend api 
		  // Send formData object 
		}
		if(this.state.selectedPdfFile) {
			axios
				.get(apiUri + "/dando/" + dandoId.dandoId + "/upload/pdf")
				.then(res => {
					this.setState({
						uploadPdfFileName: res.data.data['fileURL']
					});

					var axiosUploader = axios.create();
					delete axiosUploader.defaults.headers.common['Authorization'];
					axiosUploader.put(this.state.uploadPdfFileName, this.state.selectedPdfFile)
					.then(res => {
						NotificationManager.success("PDF File Uploaded Successfully", "Success");
					});
				})
				.catch(err => {
					console.log(err);
					NotificationManager.error("Failed to upload file: PDF", "Error");
				});

			this.setState({ fileUploadOpen: false });
		  // Request made to the backend api 
		  // Send formData object 
		}

		axios.put(apiUri + "/dando/"+ dandoId.dandoId, {status: this.state.EditDandOFile.status})
		.then(json => {
			this.setState({UpdateDandOResult: json.data});
			
		})
		.catch(err => {
			console.log("Failed to create risk assessment " + err);
			this.setState({error: err.response.data.message});
			NotificationManager.error("Failed to update status", "Error");
		})

	}; 

	handleTrash = (filledCase) => this.setState({
		openDelete: true,
		deleteModalData: filledCase
	})

	render() {
		let props = this.props;
		let state = this.state;
		const { routeName, className, enableDandO, enableView } = this.state;
		const { firmSettings = {} } = this.props;

		const columns = dandOEntriesColumns({
			routeName,
			className,
			enableDandO,
			enableView,
			firmSettings,
			goToCases: this.goToCases,
			handleEnable: this.handleEnable,
			handleEdit: this.handleEdit,
			handleTrash: this.handleTrash,
			handleInfo: this.handleInfo,
			handleViewer: this.handleViewer,
			handleFileUpload: this.handleFileUpload,
			handleRiskImport: this.handleRiskImport,
			handleCompanyRisk: this.handleCompanyRisk,
		});

		return (
			<React.Fragment>
				<Modal open={this.state.open} onClose={this.onCloseModal}>
					<div className="ModalWindow modaladd">
					<FaTimes className="closeicon" onClick={this.onCloseModal} />
					<h3 className="modalHeading">{state.heading}</h3>
					<div className="NavDivider"></div>
					<table>
						<thead></thead>
						<tbody>
						<tr>
							<td className="modalTd">
							Risk Name:
							</td>
							<td style={{ paddingTop: 16 }}>
							<input
								id="search"
								type="text"
								className="searchBox2"
								value={state.EditDandOData.companyName || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditDandOData,
									evt.target.value,
									"companyName"
								);
								}}
							/>
							<span id="error-style">{this.state.companyNameError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Risk Assessment Date</td>
							<td style={{ paddingTop: 16 }}>
							<DatePicker
								className="searchBox2"
								selected={state.EditDandOData.riskAssessmentDate || ""}
								onChange={evt =>
								this.handleOnChange(
									state.EditDandOData,
									evt,
									"riskAssessmentDate"
								)
								}
								dateFormat="yyyy-MM-dd"
							/>
							<span id="error-style">
								{this.state.riskAssessmentDateError}
							</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Ticker</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								onKeyPress={$event => allowAlphaNumeric($event)}
								value={state.EditDandOData.ticker || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditDandOData,
									evt.target.value,
									"ticker"
								);
								}}
							/>
							<span id="error-style">{this.state.tickerError}</span>
							</td>
						</tr>
						 <tr>
						 <td className="modalTd">CapIQ Identifier</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								onKeyPress={$event => allowAlphaNumeric($event)}
								value={state.EditDandOData.identifier || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditDandOData,
									evt.target.value,
									"identifier"
								);
								}}
							/>
							<span id="error-style">{this.state.identifierError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">SIC Code</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								onKeyPress={$event => onlyNumeric($event)}
								value={state.EditDandOData.sicCode || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditDandOData,
									evt.target.value,
									"sicCode"
								);
								}}
							/>
							<span id="error-style">{this.state.sicCodeError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">CIK Code</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								onKeyPress={$event => onlyNumeric($event)}
								value={state.EditDandOData.cik || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditDandOData,
									evt.target.value,
									"cik"
								);
								}}
							/>
							<span id="error-style">{this.state.cikError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Market</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								value={state.EditDandOData.market || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditDandOData,
									evt.target.value,
									"market"
								);
								}}
							/>
							<span id="error-style">{this.state.marketError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Case File</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								value={state.EditDandOData.caseFile || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditDandOData,
									evt.target.value,
									"caseFile"
								);
								}}
							/>
							<span id="error-style">{this.state.caseFileError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Notes:</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								value={state.EditDandOData.notes || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditDandOData,
									evt.target.value,
									"notes"
								);
								}}
							/>
							<span id="error-style">{this.state.notesError}</span>
							</td>
						</tr>
						{state.enableDandO ? (
							<tr>
							<td className="modalTd">Status</td>
							<td
								style={{ paddingTop: 16, zIndex: 1 }}
								className="relativePos"
							>
								<select
								style={{ width: "100%" }}
								className="statusSelect"
								value={state.EditDandOData.status || ""}
								onChange={evt => {
									this.handleOnChange(
									state.EditDandOData,
									evt.target.value,
									"status"
									);
								}}
								>
								<option value="SUBMITTED">SUBMITTED</option>
								<option value="REJECTED">REJECTED</option>
								<option value="PROCESSING">PROCESSING</option>
								<option value="COMPLETED">COMPLETED</option>
								</select>
							</td>
							</tr>
						) : null}
						
						<tr>
							<td className="modalTd">Industry Index </td>
							<td
							style={{ paddingTop: 16, zIndex: 1, width: "60%", color: "black"  }}
							className="relativePos"
							>
							<Select
								style={{ width: "100%", zIndex: 100, color: "black"  }}
								width="100%"
								name="indexListId"
								defaultValue={state.indexList[this.setSelectDefault(state.EditDandOData.indexListId)]}
								onChange={this.handleSelectChange}
								options={state.indexList}

							/> 
							 <span id="error-style">{this.state.indexListIdError}</span>
							</td>
						</tr>
						</tbody>
					</table>
					<div className="btnHolder">
						<br />
						<button
						className="btn btnS"
						onClick={evt => {
							this.handleSaveDandO(state.EditDandOData);
						}}
						>
						Save
						</button>
						&nbsp; &nbsp;
						<button
						className="btn btnC"
						onClick={evt => {
							this.setState({ open: false, EditDandOData: {} });
							this.resetErrorStat();
						}}
						>
						Cancel
						</button>
					</div>
					</div>
				</Modal>
				<Modal open={this.state.fileUploadOpen} onClose={this.onCloseUploadModal}>
					<div className="ModalWindow modaladd">
						<FaTimes className="closeicon" onClick={this.onCloseUploadModal} />
						<h3 className="modalHeading">Upload Risk File</h3>
						<div className="NavDivider"></div>
						<table>
							<thead></thead>
							<tbody>
							<tr>
								<td className="modalTd">
								Risk Name:
								</td>
								<td style={{ paddingTop: 16 }}>
								<input
									id="companyName"
									type="text"
									className="searchBox2"
									value={state.EditDandOFile.companyName || ""}
									readOnly
									
								/>
								</td>
							</tr>
							<tr>
								<td className="modalTd">Risk Assessment Date</td>
								<td style={{ paddingTop: 16 }}>
								<input
									className="searchBox2"
									value={state.EditDandOFile.riskAssessmentDate_UI || ""}
									readOnly
									
								/>
								</td>
							</tr>
							<tr>
								<td className="modalTd">Ticker</td>
								<td style={{ paddingTop: 16 }}>
								<input
									type="text"
									className="searchBox2"
									onKeyPress={$event => allowAlphaNumeric($event)}
									value={state.EditDandOFile.ticker || ""}
									readOnly
								/>
								</td>
							</tr>
							<tr>
								<td className="modalTd">Upload File (xlsx)</td>
								<td style={{ paddingTop: 16 }}>
								<input
									type="file"
									name="excelFile"
									className="searchBox2 btn btnC"
									onChange={evt => {
									this.handleOnFileChange(
										evt
									);
									}}
								/>
								<span id="error-style" style={{color: "white"}}>{this.state.selectedExcelFileName?this.state.selectedExcelFileName:""}</span>
								</td>
							</tr>
							<tr>
								<td className="modalTd">Upload File (pdf)</td>
								<td style={{ paddingTop: 16 }}>
								<input
									type="file"
									name="pdfFile"
									className="searchBox2 btn btnC"
									onChange={evt => {
									this.handleOnFileChange(
										evt
									);
									}}
									
								/>
								<span id="error-style" style={{color: "white"}}>{this.state.selectedPdfFileName?this.state.selectedPdfFileName:""}</span>
								</td>
							</tr>
							
							{state.enableDandO ? (
								<tr>
								<td className="modalTd">Status</td>
								<td
									style={{ paddingTop: 16, zIndex: 1 }}
									className="relativePos"
								>
									<select
									style={{ width: "100%" }}
									className="statusSelect"
									value={state.EditDandOFile.status || ""}
									onChange={evt => {
										this.handleDandOStatusOnChange(
										state.EditDandOFile,
										evt.target.value,
										"status"
										);
									}}
									>
									<option value="SUBMITTED">SUBMITTED</option>
									<option value="REJECTED">REJECTED</option>
									<option value="PROCESSING">PROCESSING</option>
									<option value="COMPLETED">COMPLETED</option>
									</select>
								</td>
								</tr>
							) : null}
							</tbody>
						</table>
						<div className="btnHolder">
							<br />
							<button
							className="btn btnS"
							onClick={evt => {
								this.handleOnFileUpload(state.EditDandOFile);
							}}
							>
							Upload
							</button>
							&nbsp; &nbsp;
							<button
							className="btn btnC"
							onClick={evt => {
								this.setState({ fileUploadOpen: false, EditDandOFile: {} });
								this.resetErrorStat();
							}}
							>
							Cancel
							</button>
						</div>
					</div>
				</Modal>
				<Modal
					open={this.state.openDelete}
					onClose={this.onCloseModal}
					className="deltemodal"
				>
					<div>
					<FaTimes className="deleteicon" onClick={this.onCloseModal} />
					</div>
					<div className="ModalWindow ModalDelete">
					<p style={{ textAlign: "center" }}>
						Are you sure you want to delete 
						 {" "+state.deleteModalData.companyName}?
					</p>
					<div className="textCenter">
						<button
						className="btn btnS"
						onClick={evt => {
							this.handleDelete(state.deleteModalData);
						}}
						>
						Delete
						</button>
						&nbsp; &nbsp;
						<button
						className="btn btnC"
						onClick={evt => {
							this.setState({ openDelete: false, deleteModalData: {} });
						}}
						>
						Cancel
						</button>
					</div>
					</div>
				</Modal>
				<Modal
					open={this.state.viewerModal}
					onClose={this.onCloseViewerModal}
					className="viewermodal"
				>
					<div>
					<FaTimes className="closeicon"  onClick={this.onCloseViewerModal} />
					</div>
					<div className="ModalWindow modaladd">
					
						<iframe 
							title="PreviewFile"
							width="600"
							height="400"
							scrolling="auto"
							src={this.state.viewerFileUrl}
							/>
					</div>
				</Modal>
				{/* //	DandOInfo model start */}
				<Modal
					open={this.state.DandOInfo}
					onClose={this.onCloseDandOInfoModal}
					focusTrapped={true}
				>
					<div className="ModalWindow modaladd">
					<FaTimes
						className="closeicon"
						onClick={this.onCloseDandOInfoModal}
					/>
					<h3 className="modalHeading">Risk Information</h3>
					<div className="NavDivider"></div>
					<DisclosureModal
						type="DisclosureReadonly"
						createFormState={this.state.currentDandO}
					/>
					<div>
						<div className="NavDivider"></div>
					</div>
					</div>
				</Modal>
				{/* //	DandOInfo model end */}

				<TableGrid
					columns = {columns}
					data = {state.dandoDataArray}
					handleSort = {props.handleSorting}
					sortValue = {props.sortValue}
					sortOrder = {props.sortOrder}
				/>

			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		currentDandOs: state.dandos.currentDandOs,
		currentPage: state.dandos.currentPage,
		totalDandOs: state.dandos.totalDandOs,
		totalPages: state.dandos.totalPages,
		firmSettings: state.firmSettings,
		DandOInfo: state.dandos.DandOInfo
	};
};
const mapDispatchToProps = dispatch => {
	return {
		requestPageOfDandOs: (page, sortValue, sortOrder) =>
			dispatch(requestPageOfDandOs(page, sortValue, sortOrder)),
		editInput: DandOData => {
			dispatch({ type: "LOAD_UPDATED_DANDOS", value: DandOData });
		},
		getDandOInfoById: id => dispatch(getDandOInfoById(id))
	};
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(DandOEntries));



// WEBPACK FOOTER //
// ./src/dandos/DandOEntries.js